import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "sonner";

import {TOAST_CONFIG} from "@/lib/constansts";
import {useInvalidate} from "@/src/modules/core/hooks";
import {errorHandler} from "@/src/modules/core/lib";
import {captureDomainSubmitError} from "@/src/modules/core/lib/glitchtip/parking-capture";
import type {PermanentParkingPermitStatusBody} from "../schemas";
import {permanentParkingService} from "../services";

export function usePermanentParkingPermitStatus() {
  const queryClient = useQueryClient();
  const invalidatePermits = useInvalidate("permanentparkingpermits");

  return useMutation({
    mutationFn: ({permitId, body}: {permitId: number; body: PermanentParkingPermitStatusBody}) =>
      permanentParkingService.updatePermitStatus(permitId, body),
    retry: false,
    onError: (error) => {
      captureDomainSubmitError(error, {
        feature: "permanentparking",
        operation: "permanent_parking_permit_status_update",
      });
      errorHandler(error);
    },
    onSuccess: () => {
      invalidatePermits();
      queryClient.invalidateQueries({queryKey: ["permanentparkingpermit"]});
      toast.success("Permit status updated successfully", TOAST_CONFIG);
    },
  });
}
